export type IPaginationProps = {
  countPages: number;
  currentPage: number;
  changeCurrentPage: (pageNumber: number) => void;
  dontScrollOnChange?: boolean;
};

export enum CONFIG_PAGINATION {
  first,
  second,
  third,
  fourth,
  fifth,
  sixth,
}
